import './App.css'
import { BrowserRouter as Router } from 'react-router-dom'

import { useAuth } from 'utils/auth-context'
import AuthenticatedApp from 'authenticated-app'
import UnAuthenticatedApp from 'unauthenticated-app'
import { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { setToken } from 'utils/storage.utils'

export default function App() {
  const { data, setLoginData } = useAuth()
  const user = data?.user
  const [tokenState, setTokenState] = useState<string | null>(null)
  const [, setUser] = useState<any>(null)
  const [messages, setMessages] = useState<any>(null)

  const urlParams = new URLSearchParams(window.location.search)
  const isEmbedded = urlParams.get('embedded')

  useEffect(() => {
    window.top?.postMessage({ maintenanceLoaded: true }, '*')
  }, [])

  useEffect(() => {
    const messageHandler = (event: MessageEvent<{ token: string; user: any }>) => {
      if (typeof event.data !== 'object') return
      if (typeof event.data.token !== 'string') return

      console.log(event.data);

      setLoginData({ token: event.data.token, user: event.data.user } as any)

      setUser(event.data.user)
      setToken(event.data.token)
      setTokenState(event.data.token)
      setMessages(Math.random() * 1000)
      // setIsEmbedded(true);
    }

    queryClient.cancelMutations()
    queryClient.cancelQueries()
    queryClient.invalidateQueries()
    // queryClient.refetchQueries();

    window.addEventListener('message', messageHandler)

    return () => {
      window.removeEventListener('message', messageHandler)
    }
  }, [messages])

  const queryClient = useQueryClient()

  if (isEmbedded) {
    return (
      <Router basename={process.env.PUBLIC_URL}>{tokenState  && <AuthenticatedApp isEmbedded={true} />}</Router>
    )
  }
  return (
    <Router basename={process.env.PUBLIC_URL}>
      {user ? <AuthenticatedApp isEmbedded={false} /> : <UnAuthenticatedApp />}
    </Router>
  )
}
